export default {"src":"/_next/static/media/blockquote.ffcd21d6.svg","height":10,"width":12};